import toast from "react-hot-toast";

export const copyToClipboard = async (value: string, label: string) => {
  if (!value || typeof navigator === "undefined") {
    return;
  }

  try {
    await navigator.clipboard.writeText(value);
    toast.success(`${label} copied to clipboard`);
  } catch {
    toast.error(`Unable to copy ${label.toLowerCase()}`);
  }
};

const escapeHtml = (value: string) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

export const copyLinkToClipboard = async ({
  label,
  text,
  url,
}: {
  label: string;
  text: string;
  url: string;
}) => {
  if (!url || typeof navigator === "undefined") {
    return;
  }

  try {
    if (
      typeof ClipboardItem !== "undefined" &&
      typeof navigator.clipboard.write === "function"
    ) {
      const html = `<a href="${escapeHtml(url)}">${escapeHtml(text)}</a>`;
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([url], { type: "text/plain" }),
        }),
      ]);
    } else {
      await navigator.clipboard.writeText(url);
    }
    toast.success(`${label} copied to clipboard`);
  } catch {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(`${label} copied to clipboard`);
    } catch {
      toast.error(`Unable to copy ${label.toLowerCase()}`);
    }
  }
};
